export const state = () => ({
  championshipInvitationList: null,
  athleteId: null,
  lastFetchAt: null
})

export const getters = {
  championshipInvitationList(state) {
    return state.championshipInvitationList
  },
  hasValidInvitationFor: state => championshipId => {
    const invitations = state.championshipInvitationList || []
    return invitations.some(i => i.championshipId === championshipId && !i.isExpired)
  }
}

export const mutations = {
  championshipInvitationList(state, championshipInvitationList) {
    state.championshipInvitationList = championshipInvitationList
  },
  athleteId(state, athleteId) {
    state.athleteId = athleteId
  },
  lastFetchAt(state, timestamp) {
    state.lastFetchAt = timestamp
  }
}

export const actions = {
  async load({ state, commit }, athlete) {
    /**
     * Cache in order to prevent multiple API requests caused by the issue described in
     * `middleware/championshipRegistrationForm.js`
     */
    const now = Date.now()
    const hasCache =
      !!state.championshipInvitationList &&
      state.athleteId === athlete.id &&
      state.lastFetchAt &&
      now - state.lastFetchAt < 60000

    if (hasCache) return

    const response = await this.$coreApi.$get(`/athletes/championship_invitations`)

    commit('championshipInvitationList', response.data)
    commit('athleteId', athlete.id)
    commit('lastFetchAt', now)
  }
}
